import React from 'react';
import { Tag } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { translate } from '@portal/services/i18n';
import { TransactionRequestStatus } from '@portal/enum/approvalsType';

export const renderStatusWithColor = (status: number) => {
  const getStatusText = () => {
    try {
      return translate(
        `PAGES.HOME.APPROVED.DETAILS.STATUS_TRANSACTION.${TransactionRequestStatus[status]}`
      );
    } catch (error) {
      return `Status ${status}`;
    }
  };

  const statusMap: Partial<
    Record<
      TransactionRequestStatus,
      { color: string; icon: React.ReactElement | null }
    >
  > = {
    [TransactionRequestStatus.EXECUTED]: {
      color: 'success',
      icon: React.createElement(CheckCircleOutlined),
    },
    [TransactionRequestStatus.SCHEDULE]: {
      color: 'blue',
      icon: React.createElement(ClockCircleOutlined),
    },
    [TransactionRequestStatus.FAILED]: {
      color: 'error',
      icon: React.createElement(ExclamationCircleOutlined),
    },
    [TransactionRequestStatus.REPROVED]: {
      color: 'error',
      icon: React.createElement(ExclamationCircleOutlined),
    },
  };

  const getStatusConfig = () => {
    const config = statusMap[status] || { color: 'default', icon: null };
    return {
      ...config,
      text: getStatusText(),
    };
  };

  const config = getStatusConfig();

  return React.createElement(
    Tag,
    {
      icon: config.icon,
      color: config.color,
      className: 'status-tag',
    },
    config.text
  );
};

export default renderStatusWithColor;
